
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 8a4 4 0 100-8 4 4 0 000 8zm2.8 1h-.522a5.446 5.446 0 01-4.556 0H4.2A4.201 4.201 0 000 13.2v1.3A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-1.3C14 10.881 12.119 9 9.8 9z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.354 8.31a.5.5 0 010-.707l4.75-4.75a.5.5 0 01.706 0l.836.837a.5.5 0 010 .707l-4.75 4.75a.5.5 0 01-.706 0l-.836-.837z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.19 2.854a.5.5 0 01.707 0l4.75 4.75a.5.5 0 010 .706l-.837.836a.5.5 0 01-.707 0l-4.75-4.75a.5.5 0 010-.706l.837-.836z","fill":"currentColor"}})])
          )
        }
      }
    